import 'bootstrap/dist/css/bootstrap.css'
import 'babel-polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import reduxThunk from 'redux-thunk'
import App from './components/App'
import reducers from './reducers'
// Development only axios helpers

function noop() {}

if (process.env.NODE_ENV !== 'development') {
	console.log = noop;
	console.error = noop;
	console.warn = noop;
}

//import axios from 'axios';
//window.axios = axios;

const store = createStore(reducers,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
	applyMiddleware(reduxThunk));

ReactDOM.render(
	<Provider store={store}><App /></Provider>,
	document.querySelector('#root')
);



// WEBPACK FOOTER //
// ./src/index.js